module.exports = __webpack_public_path__ + "img/05.930d7194.jpg";